module.exports = __webpack_public_path__ + "static/img/miPad2.86bedf30.jpg";